// Customer attributes: the rules for a contact's `attributes` object, shared
// by the API that saves them and the editor on the contact.

import { ATTRIBUTE_KEY_RE, RESERVED_ATTRIBUTE_KEYS } from './validate';

export const ATTRIBUTE_LIMITS = { count: 50, valueLength: 500 } as const;

export type AttributesCheck = { ok: true; attributes: Record<string, string> } | { ok: false; error: string };

/** Check a whole attributes object. Values are trimmed; an empty value
 *  removes the key, so clearing a field in the editor deletes it. */
export function normalizeAttributes(input: unknown): AttributesCheck {
  if (typeof input !== 'object' || input === null || Array.isArray(input)) return { ok: false, error: 'attributes must be an object' };
  const out: Record<string, string> = {};
  for (const [key, raw] of Object.entries(input)) {
    if (!ATTRIBUTE_KEY_RE.test(key)) return { ok: false, error: `${key}: keys are lower-case letters, digits or _, starting with a letter` };
    if (RESERVED_ATTRIBUTE_KEYS.has(key)) return { ok: false, error: `${key} is a built-in contact field` };
    if (typeof raw !== 'string') return { ok: false, error: `${key}: value must be text` };
    const value = raw.trim();
    if (value.length > ATTRIBUTE_LIMITS.valueLength) return { ok: false, error: `${key}: at most ${ATTRIBUTE_LIMITS.valueLength} characters` };
    if (value !== '') out[key] = value;
  }
  if (Object.keys(out).length > ATTRIBUTE_LIMITS.count) return { ok: false, error: `at most ${ATTRIBUTE_LIMITS.count} attributes` };
  return { ok: true, attributes: out };
}
